import Vue from 'vue';
import Vuex from 'vuex';
import base from './modules/base';
import user from './modules/user';
import setting from './modules/setting';
import content from './modules/content';

Vue.use(Vuex);

// store创建工厂
class storeFactory {
  static getInstance = () => {
    const store = new Vuex.Store({
      modules: {
        base,
        user,
        setting,
        content
      },
    });
    return store;
  }
}

export default storeFactory.getInstance();



// WEBPACK FOOTER //
// ./src/store/index.js